import axios from 'axios';
import tw from 'twin.macro';
import React, { useState } from 'react';
import { Textarea, TextInput, Alert } from 'flowbite-react';
import { customTextInputTheme } from '../flowbiteCustomThemes/textinput';
import { BASE_URL } from '../../index';

const PrimaryButton = tw.button`font-bold px-8 lg:px-10 w-full py-3 rounded-full bg-primary-500 text-gray-100 focus:bg-primary-700 focus:shadow-outline focus:outline-none transition duration-300`;

const LoadingBar = ({ progress }) => {
    const barStyles = {
        width: `${progress}%`,
        height: '7px',
        backgroundColor: '#00719c',
        transition: 'width 0.3s ease-in-out',
        top: 0,
        left: 0,
        position: 'fixed',
        zIndex: 9999,
    };

    return <div style={barStyles} />;
};

function AppointmentForm() {
    const [userDetails, setUserDetails] = useState({
        name: '',
        email: '',
        comment: '',
    });

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertColor, setAlertColor] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const handleInputChange = (e) => {
        setUserDetails({
            ...userDetails,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let currentProgress = 0;
            const interval = setInterval(() => {
                currentProgress += 15;
                setProgress(currentProgress);
                if (currentProgress >= 100) {
                    clearInterval(interval);
                }
            }, 500);

            await axios.post(`${BASE_URL}/api/send-quotation`, userDetails);
            setAlertColor('success');
            setAlertTitle('Success!');
            setAlertMessage('Je aanvraag is verzonden!');
            setShowAlert(true);
        } catch (error) {
            setAlertColor('failure');
            setAlertTitle('Error!');
            setAlertMessage('Er is iets fout gegaan tijdens het versturen, probeer het later opnieuw.');
            setShowAlert(true);
        } finally {
            setLoading(false);
            setProgress(0);
        }
    };

    return (
        <>
            {loading && <LoadingBar progress={progress} />}
            <div className="w-full max-w-sm my-10 relative z-[1000]">
                <div className="fixed m-3 top-0 left-0 right-0">
                    {showAlert && (
                        <Alert color={alertColor} withBorderAccent onDismiss={() => setShowAlert(false)}>
                            <span className="font-medium">{alertTitle} </span>{alertMessage}
                        </Alert>
                    )}
                </div>
            </div>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                <div>
                    <div className="mb-2 block">
                        <TextInput
                            theme={customTextInputTheme}
                            id="name"
                            type="text"
                            name="name"
                            placeholder="Je naam"
                            onChange={handleInputChange}
                            shadow
                            required
                        />
                    </div>
                </div>
                <div>
                    <div className="mb-2 block">
                        <TextInput
                            theme={customTextInputTheme}
                            id="phone"
                            type="text"
                            name="phone"
                            placeholder="Je telefoonnummer"
                            onChange={handleInputChange}
                            required
                            shadow
                        />
                    </div>
                </div>
                <div>
                    <div className="mb-2 block">
                        <TextInput
                            theme={customTextInputTheme}
                            id="email"
                            type="email"
                            name="email"
                            placeholder="je@email.nl"
                            onChange={handleInputChange}
                            required
                            shadow
                        />
                    </div>
                </div>
                <div>
                    <div className="mb-2 block">
                        <Textarea
                            id="user_comment"
                            name="comment"
                            rows="4"
                            onChange={handleInputChange}
                            className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Noteer uw wensen en vraag eenvoudig jouw offerte hieronder aan."
                        />
                    </div>
                </div>
                <PrimaryButton type="submit">Verstuur aanvraag</PrimaryButton>
            </form>
        </>
    );
}

export default AppointmentForm;
